// extracted by mini-css-extract-plugin
module.exports = {"input":"_32bbee5fda--input--cptMO","text-align-center":"_32bbee5fda--text-align-center--ejuhK","text-align-right":"_32bbee5fda--text-align-right--gkzhz"};